/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyParameterQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PolicyParameterQueryOperator");
    }

    getFixupPrototypeFunction() { return PolicyParameterQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PolicyParameterQueryOperator>): PolicyParameterQueryOperator {
        let obj = Object.assign(new PolicyParameterQueryOperator(), model);
        PolicyParameterQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyParameterQueryOperator>): PolicyParameterQueryOperator {
        if (!model) return null;
        return PolicyParameterQueryOperator.newInstance(<PolicyParameterQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyParameterQueryOperator) {
        if (!obj) return;

        models.PolicyParameterQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyParameterQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PolicyParameterQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Policy parameter to include
     */
    is_paramterized: boolean;

}
